import { TableV2 } from '@anytag/shared-atoms';
import { useMarketplaceAutoManagedCampaignFilter } from '@anytag/shared-organisms';
import { useGetAutoManagedCampaignsQuery, useGetAutoManagedCampaignsCountQuery } from '@anytag/graphql';
import { useMarketplaceAutoManagedCampaignTable } from './hooks';
import { formatMarketplaceAutoMangedCampaigns, getMarketplaceAutoManagedCampaignVariables } from './utils';

export const MarketplaceAutoManagedCampaignList = () => {
  const { page, limit, filter } = useMarketplaceAutoManagedCampaignFilter();
  const { input, countInput } = getMarketplaceAutoManagedCampaignVariables({ filter, page, limit });
  const { data, loading } = useGetAutoManagedCampaignsQuery({ variables: { input }, fetchPolicy: 'cache-and-network' });
  const { data: countData, loading: fetchingCount } = useGetAutoManagedCampaignsCountQuery({
    variables: { input: countInput },
    fetchPolicy: 'cache-and-network'
  });
  const { columns } = useMarketplaceAutoManagedCampaignTable();

  return (
    <TableV2
      rowHeight="112px"
      columns={columns}
      loading={loading || fetchingCount}
      pagination={{ totalRecords: countData?.getAutoManagedCampaignsCount?.count || 0 }}
      data={formatMarketplaceAutoMangedCampaigns(data?.getAutoManagedCampaigns?.campaigns)}
      noTopBorderRadius
    />
  );
};
